import { IExposedInvitation } from "./invitation.interface";

export interface IOrganizationCreationDetails {
  organization: IOrgDetails;
  admin: IAdminDetails;
}

export interface IOrgDetails {
  name: string;
  address: string;
  addressNb: string;
  postalCode: string;
  location: string;
  country: string;
}

export interface IAdminDetails {
  email: string;
  lang: string;
}

export enum OrganizationCreationErrorCode {
  ORGANIZATION_NAME_TAKEN = "ORGANIZATION_NAME_TAKEN",
  EMAIL_TAKEN = "EMAIL_TAKEN",
}

export interface IExposedOrganizationSummary {
  id: number;
  name: string;
}

export interface IExposedOrganization {
  id: number;
  name: string;
  address: string;
  addressNb: string;
  postalCode: string;
  location: string;
  country: string;
  createdAt: string;
  isInstance: boolean;
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
}

export interface IExposedUserInOrg {
  id: number;
  userID: number;
  orgID: number;
  roleID: number;
  roleName: string;
  email: string;
  status: UserStatus;
  createdAt: string;
}

export interface IOrganizationDetails {
  details: IExposedOrganization;
  members: IExposedUserInOrg[];
  invitations: IExposedInvitation[];
}

export enum MemberManagementErrorCode {
  SUPER_ADMIN_ONLY = "SUPER_ADMIN_ONLY",
  CANNOT_MODIFY_SELF = "CANNOT_MODIFY_SELF",
  LAST_ADMIN = "LAST_ADMIN",
  LAST_SUPER_ADMIN = "LAST_SUPER_ADMIN",
}

export interface IExposedOrganizationOverview {
  organization: IExposedOrganization;
  userCount: number;
}
